<!--
 * @Author: FengXiao
 * @Date: 2020-07-27 16:59:52
 * @LastEditors: FengXiao
 * @LastEditTime: 2020-09-10 01:07:29
-->
<template>
  <div class="record-detail-page page-container">
    <video-player :datas="videoData" :speaker="speaker" :allowEvent.sync="playerAllowEvent"
      :viplock="vip_lock"></video-player>
    <div class="content">
      <div class="container-wrap" :class="{ 'no-recommend': !recommendList.length }">
        <div class="left-bl clearfix">
          <h1 class="detail_title">{{ topic.title }}</h1>
          <div class="detail_meta" v-if="detailMeta">{{ detailMeta }}</div>
          <transition name="el-fade-in-linear">
            <!-- 隐私改版：无文稿时显示占位提示 -->
            <div v-if="draft" key="draft" class="child-bl" v-html="draft"></div>
            <div v-else key="empty" class="draft-empty">本篇暂无文稿</div>
          </transition>
        </div>
        <div class="right-bl">
          <recommend-videos :datas="recommendList" @click="onClickRecommend"></recommend-videos>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VideoPlayer from '@/components/AppVideoPlayer';
import RecommendVideos from '@/components/AppRecommendVideos';
import requestApi from '@/service';

import configFields from '@/utils/configFields';
const { DRAFT_TYPE } = configFields;
export default {
  name: 'RecordDetail',
  components: {
    VideoPlayer,
    RecommendVideos,
  },
  data() {
    return {
      videoData: {},
      vip_lock: false,
      playerAllowEvent: false, // 允许当前视频支持键盘事件
      speaker: {},
      recommendList: [],
      topic: {},
      draft: '',
      recordId: null,
    };
  },
  mounted() {
    this.init();
    this.getDarft(true); // 隐私改版：文稿常驻展示，进入页面即加载
  },
  watch: {
    $route(to) {
      if (to.path === '/record/detail') {
        this.init();
        this.draft = '';
        this.getDarft(true); // 隐私改版：切换视频时文稿跟随刷新
      }
    },
  },
  computed: {
    detailMeta() {
      // 讲者 · 城市 · 日期
      return [this.speaker && this.speaker.name, this.topic.city, this.topic.date].filter(Boolean).join(' · ');
    },
  },
  methods: {
    init() {
      Object.assign(this.$data, this.$options.data());
      this.recordId = this.$route.query.id;
      this.getData();
      this.getRecommend();
      this.initScrollTop();
    },
    getData() {
      requestApi(`/v3/api/site/record/${this.recordId}/detail/`).then(({ record }) => {
        const { speaker, cover, video_url, title, city, date, titlelanguage, member_type } = record;
        // 使用 map 方法替换 video_url 中的 http:// 为 https://
        const updatedVideoUrls = video_url.map(item => {
          if (item.video_url) {
            item.video_url = item.video_url.replace('http:', 'https:');
          }
          return item;
        });
        this.videoData = {
          cover,
          videoUrls: updatedVideoUrls,
          intro: titlelanguage,
        };
        this.speaker = speaker;
        this.topic = {
          title,
          city,
          date,
          intro: titlelanguage,
        };
        document.title = `${title} - 一席`;
        if (member_type == 2) {
          // 隐私改版：付费内容一律上锁，引导下载一席App观看
          this.vip_lock = true
        }
      });
    },
    getRecommend() {
      const url = `/v3/api/site/record/${this.recordId}/recommend/`;
      requestApi(url).then(({ recommended }) => {
        this.recommendList = recommended && recommended.length ? recommended : [];
      });
    },
    /**
     * @description: 获取演讲稿
     */
    getDarft(silent = false) {
      return new Promise(resolve => {
        requestApi('/v3/api/site/draft/', {
          id: this.recordId,
          type: DRAFT_TYPE.record,
        }).then(({ draft }) => {
          if (draft) {
            this.draft = draft;
            resolve(true);
          } else {
            if (!silent) this.$message.error('未找到文稿');
            resolve(false);
          }
        });
      });
    },
    inputFocus(val) {
      if (val) {
        this.playerAllowEvent = false;
      }
    },
    onClickRecommend(id) {
      this.$router.push({
        path: '/record/detail',
        query: {
          id,
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.detail_title {
  font-size: 28px;
  font-weight: 600;
  color: #333;
  line-height: 1.5;
  margin: 4px 0 8px;
}

.detail_meta {
  font-size: 14px;
  color: #999;
  line-height: 1.5;
  margin: 0 0 20px;
}

.video-actions-bl {
  position: relative;
  width: 100%;
  text-align: center;
}

.content {
  .container-wrap {
    // 无推荐内容时左栏撑满整行
    &.no-recommend {
      .left-bl {
        width: 100%;
        max-width: 100%;
      }
      .right-bl {
        display: none;
      }
    }

    display: flex;
    align-items: flex-start;
    margin: 20px auto 100px;
  }

  .left-bl {
    width: 72%;
    max-width: 827px;
    margin-right: 10px;
    box-sizing: border-box;
    background: $C1;
    padding: 20px;
  }

  .right-bl {
    width: 28%;
    background-color: $C10;
  }
}

.draft-empty {
  padding: 80px 0;
  text-align: center;
  font-size: 14px;
  color: #999999;
}
</style>
